import { createSelector } from 'reselect';
import { StoreState } from '../../store-interfaces';
import { AvailablePage } from '../../interfaces/connected-page';

const selectAvailablePages = (state: StoreState) =>
  state.connectedPage.availablePages.data;

const getUnconnectedPages = (availablePages: AvailablePage[]) => availablePages;

export const unconnectedPagesSelector = createSelector(
  [selectAvailablePages],
  getUnconnectedPages,
);
